import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { KEYS } from '../../constants/keys.js';
import { nth } from '../../utils/util.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var StyledAccordion = styled.div.withConfig({
  displayName: "AccordionGroup__StyledAccordion",
  componentId: "sc-1mqmupr-0"
})(["&&{display:flex;flex-direction:column;width:100%;}"]);
var AccordionGroup = /*#__PURE__*/React.forwardRef(function AccordionGroup2(props, ref) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusIndex = _React$useState2[0],
    setFocusIndex = _React$useState2[1];
  function handleKeydown(e) {
    e.stopPropagation();
    var indices = React.Children.map(children, function (child, i) {
      return i;
    });
    switch (e.key) {
      case KEYS.ARROW_UP:
        e.preventDefault();
        return setFocusIndex(function (prev) {
          return nth(indices, indices.indexOf(prev) - 1);
        });
      case KEYS.ARROW_DOWN:
        e.preventDefault();
        return setFocusIndex(function (prev) {
          return nth(indices, indices.indexOf(prev) + 1);
        });
      case KEYS.HOME:
        e.preventDefault();
        return setFocusIndex(function () {
          return indices[0];
        });
      case KEYS.END:
        e.preventDefault();
        return setFocusIndex(function () {
          return indices[indices.length - 1];
        });
    }
  }
  function handleHeaderEvent(e, index) {
    if (e.type === "focus") {
      setFocusIndex(index);
      return;
    }
    handleKeydown(e);
  }
  return /*#__PURE__*/jsx(StyledAccordion, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    children: React.Children.map(children, function (child, index) {
      return /*#__PURE__*/React.cloneElement(child, {
        onHeaderEvent: handleHeaderEvent,
        index: index,
        focused: focusIndex === index
      });
    })
  }));
});
AccordionGroup.displayName = "AccordionGroup";

export { AccordionGroup };
